import { calcQuantityDiscountPrice } from "public/utils/calc-quantity-discount-price";
import { transformPriceMapByAspectKeyToDiscountPriceMapByAspectKey } from "public/utils/transform-variation-item-to-price-map-by-aspect-key";

/**
 * @param {Object} args
 * @param {Object} args.product
 * @param {Object[]} args.offers
 * @param {Map<string, number>} args.priceMapByAspectKey
 */
export function transformOffersToPreviewData(args) {
  const { offers, product, priceMapByAspectKey } = args;

  return offers.map((offer) => {
    const { _id, title, quantityFrom } = offer;
    const quantity = quantityFrom;

    const discountPrice = calcQuantityDiscountPrice({
      price: product.price,
      quantity,
      offer,
    });

    const discountPriceMapByAspectKey =
      transformPriceMapByAspectKeyToDiscountPriceMapByAspectKey({
        priceMapByAspectKey,
        offer,
      });

    return {
      id: _id,
      image: {
        base64: offer.imageBase64,
        cornerRadius: offer.imageSettings?.cornerRadius,
        size: offer.imageSettings?.size
      },
      title,
      discountPrice,
      discountPriceMapByAspectKey: Object.fromEntries(
        discountPriceMapByAspectKey.entries()
      ),
      subTitle: "Standard price",
      hasDiscount: offer.amount > 0,
      quantity,
    };
  });
}
